module.exports = __webpack_public_path__ + "img/find_doctor.949826d2.png";